import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onRegisteredSW(_url, registration) {
    // The browser only checks for a new service worker on its own
    // navigation heuristic — poll explicitly so open sessions (especially
    // mobile PWAs that stay backgrounded rather than fully closed) don't
    // keep running a stale build indefinitely.
    if (registration) {
      setInterval(() => registration.update(), 60 * 60 * 1000);
    }
  },
  onNeedRefresh() {
    // registerType is 'autoUpdate' and there's no update-available UI in
    // the app, so match that intent: reload once new content is ready
    // rather than leaving stale screens running.
    updateSW(true);
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);
